import React from "react";
import {BaseThatsMeIconProps} from "../../interfaces/baseThatsMeIconProps.interface";

export default (props: BaseThatsMeIconProps) => {
    const {size = 24, ...rest} = props;
    return <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <rect x="0.5" y="4.5" width="27" height="21" fill="#83FFAD" stroke="black"/>
        <path
            d="M10.3872 21V9.79999H14.1152C14.9685 9.79999 15.6672 9.95465 16.2112 10.264C16.7552 10.5733 17.1552 10.984 17.4112 11.496C17.6672 12.008 17.7952 12.5733 17.7952 13.192C17.7952 13.8107 17.6672 14.376 17.4112 14.888C17.1552 15.4 16.7552 15.8107 16.2112 16.12C15.6672 16.4293 14.9685 16.584 14.1152 16.584H11.7312V21H10.3872ZM11.7312 15.352H14.0832C14.8725 15.352 15.4592 15.1547 15.8432 14.76C16.2272 14.3547 16.4192 13.832 16.4192 13.192C16.4192 12.552 16.2272 12.0293 15.8432 11.624C15.4592 11.2187 14.8725 11.016 14.0832 11.016H11.7312V15.352Z"
            fill="black"/>
        <rect x="0.5" y="0.5" width="10" height="4" fill="#83FFAD" stroke="black"/>
    </svg>
}
